export const TRANSLATIONS_PL = {
    breadcrumb:
    { 
        start: {
            name: 'Start',
            url: '/'
        },
        infrastructure: {
            name: 'Infrastruktura',
            url: '/infrastruktura'
        },
        catalogue: {
            name: 'Katalog zasobów',
            url: '/katalog'
        },
        search: {
            name: 'Wyszukiwarka',
            url: '/katalog/search/'
        },
        map: {
            name: 'Mapa',
            url: 'katalog/map/'
        }        
    },
    home:{
        'catalogue' : 'Katalog zasobów',
        'see_all': 'Zobacz wszystkie',
        'laboratories' : 'Laboratoria',
        'activityCategories': 'Aktywności',
        'types': 'Typy',
    },
    resources: {
        'catalogue' : 'Katalog zasobów',
        'search_result': 'Wynik wyszukiwania',
        'wynik': 'wynik',
        'wyniki': 'wyniki',
        'wynikow': 'wyników',
        'next_page': 'Następna strona >',
        'previous_page': '< Poprzednia strona'
    },
    'filterpanel': {
        'return': 'Powrót',
        'clear' : 'Usuń wszystkie filtry',
        'show_more': 'Pokaż więcej',
        'show_less': 'Pokaż mniej',
    },
    filtertags : {
        'actcat': 'Aktywność',
        'lab': 'Laboratorium',
        'am': 'Tryb dostępu',
        'kw': 'Słowo Kluczowe',
        'q': 'Wyszukanie',
        'type': 'Typ',
    },
    'resource': {
        'resource_type': 'Typ zasobu',
        'resource_accesstype': 'Typ dostępu',
        'resource_accessmode': 'Tryb dostępu',
        'resource_classification': 'Klasyfikacja',
        'resource_location': 'Lokalizacja',
        'resource_location_country': '',
        'laboratory': 'Laboratoria',
        'activity': 'Aktywności',
        'keyword': 'Słowa kluczowe',
        'standard': 'Standardy',
        'domain': 'Dziedzina nauki',
        'targetuser': 'Grupy docelowe',
        'language': 'Języki',
        'related': 'Zasoby powiązane',
        'access_data': 'Dane dostępowe',
        'supplier': 'Dostawca',
        'webpage': 'Strona',
        'contact': 'Kontakt',
        'price_list' : 'Oferta usług',
        'price_list_link' : 'cennik',
        'price_list_url' : 'cennik'
     },
     'gallery': {
        'header': 'Galeria'
     },
     'search':{
        'search_in_resources': 'Szukaj w zasobach',
        'all': 'wszystkie'
     },
    'map': {
        'name': 'Mapa zasobów',
        'show_map': 'Wyświetl mapę'
    }

}